import Template from 'pages/components/Template'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from 'components/Header'
import colors from 'globals/colors'
import Button from 'components/Button'
import { ButtonWrapper } from './styles'
import UpsertFreeAnswerModal from './UpsertFreeAnswerModal'
import ListFreeAnswers from './ListFreeAnswers'

const FreeAnswers = () => {
  const { t } = useTranslation()
  const [createModalOpened, setCreateModalOpened] = useState<boolean>(false)


  return (
    <Template
      activeMenu="/libre-réponses"
    >
      {(currentUser, currentCenters) =>
        <>
          <Header
            title={t('free-answers.title')}
            currentUser={currentUser}
            currentCenters={currentCenters}
          />
          <ButtonWrapper>
            <Button
              size="large"
              color={colors.blueGreen}
              onClick={
                () => setCreateModalOpened(
                  (createModalOpened) => !createModalOpened
                )
              }
            >
              {t('global.add')}
            </Button>
          </ButtonWrapper>
          <UpsertFreeAnswerModal
            createModalOpened={createModalOpened}
            setCreateModalOpened={setCreateModalOpened}
            currentCenters={currentCenters}
          />
          <ListFreeAnswers
            currentCenters={currentCenters}
          />
        </>
      }
    </Template>
  )
}

export default FreeAnswers
